<template>
<v-row>
    <v-col>
        {{ accountSelected ? `${accountSelected.account_no} - ${accountSelected.name}` : '-' }}
    </v-col>
    <v-col>
        <v-dialog v-model="dialog">
            <template #activator="{on}">
                <v-btn v-on="on">Change</v-btn>
            </template>
            <v-card :disabled="loading" :loading="loading">
                <v-card-title>Choose Account</v-card-title>
                <v-card-text>
                    <v-treeview
                        :items="accounts"
                    >
                        <template #label=" {item} " class="d-flex">
                            {{  item.account_no }} - {{ item.name }}
                            <v-btn small @click="choose(item.id)">Choose</v-btn>
                        </template>
                    </v-treeview>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="dialog=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        dialog: false,
    }),
    props: {
        value: {
            type: [Number, String],
            default: null
        }
    },
    computed:{
        ...mapGetters('bexio', ['accounts', 'loading']),
        model: {
            get () {
                return this.value
            },
            set (v) {
                this.$emit('input', v)
                this.$emit('change', v)
            }
        },
        accountSelected () {
            return this.findInArray(this.accounts, this.model)
        }
    },
    watch: {
        dialog (d) {
            if(d) {
                this.init()
            }
        }
    },
    methods: {
        ...mapActions('bexio', ['loadAccounts']),
        init() {
            if(this.accounts.length == 0){
                this.loadAccounts()
            }
        },
        choose(account) {
            this.model=account
            this.dialog = false
        },
        findInArray(datas, id) {
            for(let data of datas) {
                if(data.id == id){
                    return data
                }
                if(data.children && data.children.length > 0){
                    const childrenReturn = this.findInArray(data.children, id)
                    if(childrenReturn){
                        return childrenReturn
                    }
                }
            }
            return null
        }
    }
}
</script>